// extracted by mini-css-extract-plugin
module.exports = {"maiSui":"maiSui","quanwei":"quanwei","NewTagListItem":"NewTagListItem"};